import { FormState } from 'react-formstate';
import { validationAdapter } from 'react-formstate-validation';

export default () => {
  FormState.rfsProps.formField.suppress = false;
  FormState.rfsProps.formField.name = 'name';
  FormState.rfsProps.fsv.name = 'validator';

  FormState.showMessageOn('blur');
  FormState.setEnsureValidationOnBlur(true);

  validationAdapter.plugInto(FormState);
};



// WEBPACK FOOTER //
// ./app/Assets/js/configureFormValidation.js